import { background1 } from "assets/website";
import type { EventData } from "../data";

interface LearningsProps {
  event: EventData;
}

const numberStyle = {
  fontSize: "65px",
  lineHeight: "110%",
  letterSpacing: "-0.8px",
  WebkitTextStroke: "1px #00003F",
} as const;

const Learnings: React.FC<LearningsProps> = ({ event }) => {
  const [firstCard, ...restCards] = event.learnings;

  return (
    <section className="pb-16 pt-4 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2
            data-aos="fade-up"
            className="text-3xl md:text-4xl lg:text-5xl font-display font-[550] text-neutral-900 mb-4"
          >
            What you'll learn and why it matters
          </h2>
          <p
            data-aos="fade-up"
            data-aos-delay="100"
            className="lg:text-xl text-lg text-[#475467] mx-auto"
          >
            A structured 60-minute session. No filler. Every segment has a specific job to do.
          </p>
        </div>

        <div
          data-aos="fade-up"
          data-aos-delay="200"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto"
        >
          <div
            className={`${firstCard.bgColor} rounded-2xl px-6 py-16 md:row-span-2 relative overflow-hidden flex flex-col h-full justify-center`}
          >
            <img
              src={background1}
              alt=""
              aria-hidden="true"
              className="absolute top-0 left-0 w-full h-full object-cover pointer-events-none opacity-70"
            />
            <span
              className="absolute top-4 left-6 font-display font-semibold text-transparent"
              style={numberStyle}
            >
              {firstCard.number}
            </span>
            <div>
              <p className="relative text-lg lg:text-[22px] font-semibold text-[#050B17] mt-12">
                {firstCard.title}
              </p>
              <p className="relative text-base lg:text-xl text-[#475467] mt-3">
                {firstCard.description}
              </p>
            </div>

          </div>

          {restCards.map((learning, index) => (
            <div
              key={index}
              className={`${learning.bgColor} rounded-2xl px-6 pt-8 pb-6 flex flex-col h-full`}
            >
              <span
                className="font-display font-semibold text-transparent mb-8 sm:mb-16 -mt-6"
                style={numberStyle}
              >
                {learning.number}
              </span>
              <p className="text-lg lg:text-[22px] font-semibold text-[#050B17]">
                {learning.title}
              </p>
              <p className="text-base lg:text-xl text-[#475467] mt-3">{learning.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { Learnings };
